import React from "react";
import {withApollo} from "react-apollo";

import DashboardIcon from "@material-ui/icons/Dashboard";
import Tooltip from 'material-ui/Tooltip';
import withStyles from "material-ui/styles/withStyles";
import Button from "components/CustomButtons/Button.jsx";

import { downloadFile } from "lib/utils" ;
import Table from '../../elements/Table';
import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import IconCard from "components/Cards/IconCard";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { gq_getConversationalPins, getConversationalPinsQuery } from "../graph";
import {projectsStyle} from '../style';
import ExportPinsModal from './ExportPinsModal';

class ViewPins extends React.Component{
	constructor(props){
		super(props);

		this.state = {
		  pin_data : [],
		  headers : [
      //this is a list that sets the header order
  			{Header:"Pin",accessor:"pin", minWidth:50},
  			{Header:"Recorded Length",accessor:"currentRecordingLength"},
  			{Header:"Max Length",accessor:"maxRecordingLength", minWidth: 60},
  			{Header:"Parts",accessor:"part", minWidth:40},
  			{Header:"Owner",truekey:"pinConv.user.username",accessor:"username", Cell: row => <span title={row.value}>{row.value}</span>},
  			{Header:"Confirmation",truekey:"pinConv",accessor:"confirmation", minWidth: 60},
        {Header:"Reset",truekey:"pinConv",accessor:"reset", minWidth: 50},
  			{Header:"Actions",accessor:"actions",sortable:false,filterable:false},
		  ], 
      pages: 1, 
      loading: false, 
      exportModalOpen: false
		}
    this.fetchData = this.fetchData.bind(this)
    this.openExportPinsModal = this.openExportPinsModal.bind(this)
    this.closeExportPinsModal = this.closeExportPinsModal.bind(this)
    this.exportPins = this.exportPins.bind(this)
	}

	componentDidMount(){
    this.fetchData();
	}

  openExportPinsModal(){
    this.setState({
      exportModalOpen: true
    })
  }

  closeExportPinsModal(){
    this.setState({
      exportModalOpen: false
    })
  }

  exportPins(){
    let url = null;
    let pid = this.props.match.params.id
    url = `${process.env.REACT_APP_SERVER_URL}export_pins/${pid}`
           
    downloadFile(url, `pins-${pid}.csv`);
    this.setState({exportModalOpen: false});
  }


  fetchData(state=null, instance=null, options={}){
    this.setState({ loading: true })
    if (state){
        var filterBy = JSON.stringify(state.filtered)
        var offset = state.page
        var pageSize = state.pageSize
        var sort = JSON.stringify(state.sorted)
    } else {
        var filterBy = JSON.stringify([])
        var offset = 0
        var pageSize = 10
        var sort = JSON.stringify([])
    }
    if (offset == (this.state.pages-1)){
       options = {fetchPolicy: 'no-cache'}
    }
    let pid = this.props.match.params.id
    this.props.client.query({
      query: gq_getConversationalPins,
      variables: {
        filterBy: filterBy,
        offset: offset, 
        pageSize: pageSize,
        sort: sort, 
        pid: pid
      }, 
      options: options
    }).then((data) => {
      this.setState({
        pin_data: data.data.getConversationalPins.conversationalPins, 
        loading: false, 
        pages: data.data.getConversationalPins.pages
      });
    });
  }

	render(){
    const pinData = this.state.pin_data;
    const {classes} = this.props;

    const table_data = {
        id: "pinsTable",
        rows : pinData,
        header : this.state.headers,
        actions: ['logs'],
        buttons: {
          'logs': {
            'key':"pin",
            'url':"pin/:id",
            'style':{
              'obj':<Tooltip
                    id="tooltip-top"
                    title="View logs"
                    placement="top"
                    classes={{ tooltip: classes.tooltip }}
                  ><DashboardIcon/></Tooltip>,
              'color':'primaryNoBackground',
              'class':'',
            },
            'text':''
          }
        }
    };

    let exportModal = null;
    if (this.state.exportModalOpen){
      exportModal = <ExportPinsModal
        openExportPinsModal = {this.openExportPinsModal}
        closeExportPinsModal = {this.closeExportPinsModal}
        exportPins = {this.exportPins}
      />
    }
		return(
      <GridContainer>
        { exportModal }
        <ItemGrid xs={12}>
          <IconCard
            icon={DashboardIcon}
            title="View"
            content={
              <GridContainer>
                <ItemGrid xs={12}>
                  <Button 
                    size="sm" 
                    color="primary"
                    onClick={() => this.openExportPinsModal()}
                    >
                    <CloudDownloadIcon/>&nbsp;&nbsp;Export Pins
                  </Button>
                </ItemGrid>
                <ItemGrid xs={12}>
                  <Table 
                    title="Projects" 
                    data={table_data} 
                    pages={this.state.pages}
                    loading={this.state.loading}
                    onFetchData={this.fetchData}
                    defaultPageSize={10}></Table>
                </ItemGrid>
              </GridContainer>
            }
          />
        </ItemGrid>
      </GridContainer>
			
		)
	}
}


export default withStyles(projectsStyle)(withApollo(ViewPins))





// WEBPACK FOOTER //
// ./src/views/projects/components/ViewPins.jsx